import * as React from 'react';
import { SVGProps } from 'react';

const IconFacebookSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 6a5 5 0 1 0-5 5c.03 0 .059 0 .088-.002v-3.89H5.014V5.854h1.074v-.921c0-1.069.652-1.65 1.605-1.65.457 0 .85.032.963.048v1.117H8c-.518 0-.62.246-.62.608v.797h1.241L8.46 7.105H7.381v3.702A5.002 5.002 0 0 0 11 6Z" />
  </svg>
);
export default IconFacebookSizeXs;
